<template>
  <v-data-table
      v-model="selected"
      color="blue lighten-4"
      item-key="movimento.id"
      :headers="headers"
      :items="magazziniSorted"
      :options.sync="options"
      :server-items-length="totaleMagazzini"
      :loading="loading"
      class="elevation-1"
      :disable-sort="true"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 15, 50, 100]
      }"
      @update:options="getDataFromApi"
    >
    <template v-slot:[`item.ultimoMovimento.data`]="{ item }">
      {{ item.ultimoMovimento && item.ultimoMovimento.data && item.ultimoMovimento.data.substring(0, 22) | dateTime }}
    </template>
<!--     <template v-slot:[`item.actions`]="{ item }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon small class="mr-2" @click="editItem(item)" v-bind="attrs" v-on="on">mdi-pencil</v-icon>
        </template>
        <span>Modifica il movimento</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon small @click="deleteItem(item)" v-bind="attrs" v-on="on">mdi-delete</v-icon>
        </template>
        <span>Cancella il movimento</span>
      </v-tooltip>
    </template> -->
    <template v-slot:no-data>
      <v-btn color="primary" @click="getDataFromApi">Ricarica</v-btn>
    </template> 
    </v-data-table>
</template>

<script>
  import { dynamicSortMultiple } from '@/components/helpers.js'
  import _ from 'lodash'
  import movimenti from '@/services/movimentiService.js'
  import configurazioni from '@/services/configurazioniService.js'

  /* eslint-disable */
  export default {
    props: {
      item: Object,
      refresh: Number
    },
    data: () => ({
        totaleMagazzini: 0,
        magazzini: [],
        elencoMagazzini: [],
        selected: [],
        loading: true,
        options: {},
        headers: [
          { text: 'Magazzino', value: 'magazzino', align: 'start'},
          { text: 'Descrizione', value: 'descrizione' },
          { text: 'Giacenza', value: 'quantita' },
          { text: 'Valore', value: 'valore' },
          { text: 'Ultimo Movimento', value: 'ultimoMovimento.causale' },
          { text: 'Tipo', value: 'ultimoMovimento.tipo' },
          { text: 'Riferimento', value: 'ultimoMovimento.id' },
          { text: 'Data', value: 'ultimoMovimento.data' },
        ],
        filtri: null,
        causali: []
    }),
    watch: {
      async refresh() {
        await this.getDataFromApi()
      }
    },
    async mounted() {
      this.elencoMagazzini = await configurazioni.getConfigurazione('magazzino_magazzini', 'magazzini')
      await this.getDataFromApi()
    },
    computed: {
      magazziniSorted() {
        const els = this.magazzini
        const elSorted = els.sort(dynamicSortMultiple('magazzino'))
        return elSorted
      }   
    },
    methods: {
      async getDataFromApi () {
        try {
          this.loading = true
          // passo periodo e causali da considerare
          this.filtri = {}
          this.filtri.prodotto = this.item._id // solo il prodotto passato
          // console.log(this.filtri.prodotto)
          // this.filtri.causale = [...this.causali]
          const data = await movimenti.getMovimentiProdotto(this.filtri, this.options)
          const elenco = data && data.total_rows > 0 ? data.rows : []
          // let giacenze = {}
          let magazzini = {}
          for (let m of elenco) {
            const maga = m.magazzino || 'mag01'
            magazzini[maga] = magazzini[maga] || {}
            let mg = magazzini[maga]
            mg.magazzino = maga
            mg.descrizione = this.elencoMagazzini.find(x =>x.codice === maga).descrizione
            mg.quantita = +((mg.quantita || 0) + (m.segno === '+' ? 1 : -1) * m.quantita).toFixed(2)
            mg.valore = +((mg.valore || 0) + (m.segno === '+' ? 1 : -1) * m.valore).toFixed(2)
            mg.ultimoMovimento = mg.ultimoMovimento || {} 
            if (!mg.ultimoMovimento.data || m.data > mg.ultimoMovimento.data) {
              mg.ultimoMovimento = m.riferimento
              mg.ultimoMovimento.causale = m.causale
            }
          }
          this.magazzini = Object.values(magazzini)
          this.totaleMagazzini = Object.keys(magazzini).length
        } catch(err) {
          this.magazzini = []
          this.totaleMagazzini = 0
        } finally {
          this.loading = false
        }
      }
    
    }
  }
</script>
